/**
 * gpo-cart-guard.js
 * -----------------------------------------------------------------------------
 * 「選べる5個セット」など、Globo Product Options で “中身の選択” が必須の商品が、
 * 商品ページのフォームを通らずにカートへ入ってしまう（＝5個未選択のまま注文が
 * 成立してしまう）事故を、カート/チェックアウト側で最終的に止めるためのガード。
 *
 * 設計方針（安全第一）:
 *  - 誤ブロック（正常な注文まで止めてしまう）を絶対に避けるため、
 *    「対象商品なのに _has_gpo も 1〜5個目 も “ひとつも無い”」= 明確に未選択の時だけ発動。
 *  - 何かエラーが起きた場合は、必ず「購入を止めない」側に倒す（フェイルセーフ）。
 *  - 既存の購入ロジックは書き換えず、上から検証を1枚かぶせるだけ。
 *
 * 対象商品を増やす場合は GUARDED 配列に {productId, url, label} を足すだけ。
 */
(function () {
  'use strict';

  // ---- 設定 -----------------------------------------------------------------
  var GUARDED = [
    {
      productId: 9213308403927,          // 【数量限定！選べる5個セット】1CO-RET-06
      url: '/products/5-1cofood',
      label: '選べる5個セット'
    }
    // 今後、他のオプション必須商品を守る場合はここに追加
  ];

  var WARN_CLASS = 'gpo-guard-warning';
  var BANNER_CLASS = 'gpo-guard-banner';
  var DISABLED_FLAG = 'gpo-guard-disabled';

  // 直近の検証結果（未選択の対象商品がカートにあるか）。送信ガードで参照する。
  var blocked = false;

  // ---- ユーティリティ -------------------------------------------------------

  // その明細が「選択済み」か判定（_has_gpo または 1〜5個目 のどれかがあればOK）
  function isSelected(props) {
    if (!props) return false;
    if (props['_has_gpo']) return true;
    for (var i = 1; i <= 5; i++) {
      if (props[i + '個目']) return true;
    }
    return false;
  }

  function guardConfigFor(productId) {
    for (var i = 0; i < GUARDED.length; i++) {
      if (GUARDED[i].productId === productId) return GUARDED[i];
    }
    return null;
  }

  // カート内の「対象商品なのに未選択」の明細を返す
  function findInvalidItems(cart) {
    var items = (cart && cart.items) || [];
    return items.filter(function (item) {
      var cfg = guardConfigFor(item.product_id);
      if (!cfg) return false;
      return !isSelected(item.properties || {});
    });
  }

  function checkoutButtons() {
    return Array.prototype.slice.call(document.querySelectorAll('[name="checkout"]'));
  }

  // 通常のチェックアウト + カート内のエクスプレス決済（Apple Pay / Shop Pay 等）を無効化/解除
  function setBlocked(blocked) {
    checkoutButtons().forEach(function (btn) {
      btn.disabled = !!blocked;
      btn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      btn.style.opacity = blocked ? '0.4' : '';
      btn.style.pointerEvents = blocked ? 'none' : '';
      if (blocked) { btn.classList.add(DISABLED_FLAG); }
      else { btn.classList.remove(DISABLED_FLAG); }
    });
    // カート上のエクスプレス決済ボタン（カートを飛ばして決済に進む＝これも塞ぐ）
    Array.prototype.slice
      .call(document.querySelectorAll('.additional-checkout-buttons'))
      .forEach(function (el) { el.style.display = blocked ? 'none' : ''; });
  }

  function removeWarnings() {
    Array.prototype.slice.call(document.querySelectorAll('.' + WARN_CLASS))
      .forEach(function (el) { el.parentNode && el.parentNode.removeChild(el); });
  }

  // 未選択明細をカートから外し → 通知 → 商品ページへ（?gpo_reselect=1 でバナー表示）
  function reselect(item, cfg) {
    var go = function () {
      window.location.href = cfg.url + '?gpo_reselect=1';
    };
    try {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      }).then(go).catch(go);
    } catch (e) { go(); }
  }

  function buildWarning(item, cfg) {
    var box = document.createElement('div');
    box.className = WARN_CLASS;
    box.setAttribute('role', 'alert');
    box.style.cssText =
      'margin:12px 0;padding:14px 16px;border:1px solid #cc2b2b;border-radius:10px;' +
      'background:#fff5f5;color:#a01818;font-size:14px;line-height:1.7;text-align:left;';

    var msg = document.createElement('div');
    msg.innerHTML =
      '<strong>「' + cfg.label + '」の中身が選ばれていません。</strong><br>' +
      'そのままではご購入いただけません。下のボタンから中身を5個選び直してください。';
    box.appendChild(msg);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = '中身を選び直す';
    btn.style.cssText =
      'margin-top:10px;display:inline-block;padding:9px 18px;border:0;border-radius:8px;' +
      'background:#cc2b2b;color:#fff;font-weight:bold;font-size:14px;cursor:pointer;';
    btn.addEventListener('click', function () { reselect(item, cfg); });
    box.appendChild(btn);

    return box;
  }

  function injectWarning(item, cfg) {
    removeWarnings();
    var anchors = checkoutButtons();
    if (!anchors.length) return;
    anchors.forEach(function (btn) {
      var host = btn.closest ? (btn.closest('form') || btn.parentNode) : btn.parentNode;
      var warn = buildWarning(item, cfg);
      // チェックアウトボタンの直前に置く
      (btn.parentNode || host).insertBefore(warn, btn);
    });
  }

  // ---- 本体 ----------------------------------------------------------------
  var validating = false;
  function validate() {
    if (validating) return;
    validating = true;
    try {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          try {
            var invalid = findInvalidItems(cart);
            if (invalid.length) {
              var item = invalid[0];
              blocked = true;
              setBlocked(true);
              injectWarning(item, guardConfigFor(item.product_id));
            } else {
              blocked = false;
              setBlocked(false);
              removeWarnings();
            }
          } catch (e) {
            // フェイルセーフ：判定でこけたら購入は止めない
            blocked = false;
            setBlocked(false);
            removeWarnings();
          }
        })
        .catch(function () { /* 通信失敗時は何もしない（＝購入を止めない） */ })
        .then(function () { validating = false; });
    } catch (e) {
      validating = false;
    }
  }

  // 選び直しで戻ってきた時のバナー（商品ページ上部）
  function maybeShowReselectBanner() {
    try {
      if (window.location.search.indexOf('gpo_reselect=1') === -1) return;
      if (document.querySelector('.' + BANNER_CLASS)) return;
      var banner = document.createElement('div');
      banner.className = BANNER_CLASS;
      banner.setAttribute('role', 'status');
      banner.style.cssText =
        'margin:0 auto 12px;max-width:900px;padding:12px 16px;border:1px solid #1f8a4c;' +
        'border-radius:10px;background:#f2fbf5;color:#146c3a;font-size:14px;line-height:1.7;text-align:center;';
      banner.innerHTML =
        '未選択の「選べる5個セット」を<strong>カートから削除しました</strong>。<br>' +
        'このページで中身を5個選び、<strong>もう一度「カートに追加」を押してください。</strong>';
      var main = document.querySelector('main') || document.body;
      main.insertBefore(banner, main.firstChild);
    } catch (e) { /* バナー失敗は無視 */ }
  }

  function scrollToWarning() {
    var w = document.querySelector('.' + WARN_CLASS);
    if (w && w.scrollIntoView) {
      try { w.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { w.scrollIntoView(); }
    }
  }

  // 送信/クリックが「チェックアウト」かどうか
  function isCheckoutTrigger(el) {
    if (!el) return false;
    if (el.getAttribute && el.getAttribute('name') === 'checkout') return true;
    return !!(el.closest && el.closest('[name="checkout"]'));
  }

  // 最終ガード：blocked の間はチェックアウト送信/クリックを止める
  // （ボタンの disabled が再描画で戻っても、キーボード送信でも確実に止める）
  function onSubmitCapture(e) {
    if (!blocked) return;
    if (isCheckoutTrigger(e.submitter)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      scrollToWarning();
    }
  }
  function onClickCapture(e) {
    if (!blocked) return;
    if (isCheckoutTrigger(e.target)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      scrollToWarning();
    }
  }

  // カートの変化・ドロワー表示のたびに再検証
  function bindEvents() {
    // 最終ガード（キャプチャ段階で捕捉）
    document.addEventListener('submit', onSubmitCapture, true);
    document.addEventListener('click', onClickCapture, true);

    ['cart:change', 'cart:refresh', 'cart:error'].forEach(function (ev) {
      document.addEventListener(ev, validate);
      document.documentElement.addEventListener(ev, validate);
    });
    // カートドロワーが後から描画される場合に備え、チェックアウトボタンの出現を監視
    try {
      var obs = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType === 1 &&
                (n.matches && n.matches('[name="checkout"]') ||
                 n.querySelector && n.querySelector('[name="checkout"]'))) {
              validate();
              return;
            }
          }
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
    } catch (e) { /* 監視できなくても致命ではない */ }
  }

  function init() {
    maybeShowReselectBanner();
    validate();
    bindEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
